import ReactGA from 'react-ga4';

class Analytics {
  static pageview = (url = null) => {
    const page = url || window?.location;
    const title = document?.title || "";
    ReactGA.send({ hitType: "pageview", page: page, title: title });
  }

  /*
  * `event` static function records an event in Google Analytics (GA).
  *
  * Usage: Analytics.event({action: 'CopyButton', category: 'TextCopy', label: text});
  *
  * @params
  * action: Top level field in GA (named 'Event Name')
  * category: Second level field in GA
  * label: Lowest level field in GA, may be used to collect anonymous values
  */
  static event = (params) => {
    ReactGA.event(params);
  }
}

export default Analytics;